export function isElementVisible(element: HTMLElement): boolean {
  if (!element) return false;
  const style = window.getComputedStyle(element);
  return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
}

export function findBestTriggerElement(container: HTMLElement): HTMLElement {
  // 1. Custom range display - shown when a custom range is selected
  const customRangeDisplay = container.querySelector('.custom-range-display') as HTMLElement;
  if (customRangeDisplay && isElementVisible(customRangeDisplay)) {
    return customRangeDisplay;
  }

  // 2. The custom-range-input wrapper containing the select dropdown
  const customRangeInput = container.querySelector('.custom-range-input') as HTMLElement;
  if (customRangeInput && isElementVisible(customRangeInput)) {
    // Try to find the most specific element within v-select
    const vTextField = customRangeInput.querySelector('.v-select__selections') as HTMLElement;
    if (vTextField) {
      return vTextField;
    }

    const vInputControl = customRangeInput.querySelector('.v-input__control') as HTMLElement;
    if (vInputControl) {
      return vInputControl;
    }

    return customRangeInput;
  }

  // 3. Any visible v-input as fallback
  const vInputs = container.querySelectorAll('.v-input');
  for (let i = 0; i < vInputs.length; i += 1) {
    const input = vInputs[i] as HTMLElement;
    if (isElementVisible(input)) {
      return input;
    }
  }

  // 4. Container fallback
  return container;
}
